import * as React from 'react';
import { Button, ButtonProps } from './button';
import styles from './button-tertiary.scss';

export const ButtonTertiary: React.FC<ButtonProps> = props => {  
  const { children, ...rest } = props;
    
  return (
    <Button btnType={styles.btnTertiary} {...rest}>
      {children}
    </Button>);
  };
